import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { User } from '@/types/user';

interface UserContextType {
  user: User | null;
  setUser: Dispatch<SetStateAction<User | null>>;
  setIsAuthenticated: Dispatch<SetStateAction<boolean | null>>;
  isAuthenticated: boolean | null; // null = loading, true = authenticated, false = not authenticated
}

export const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
  setIsAuthenticated: () => {},
  isAuthenticated: null,
} as UserContextType);

export function useUserContext(): UserContextType {
  const ctx = useContext(UserContext);
  if (ctx === undefined) {
    throw new Error('UserContext not set up correctly.');
  }
  return ctx;
}
